import { combineReducers } from 'redux';

import fetchCustomPageMap, {
    fetchStationGuideAction,
} from './actions/fetchStationGuide';
import stationGuideReducerMap, {
    selectors as stationGuideSelectors,
} from './appstate';
import namespace from './types';

const reducer = combineReducers({
    ...fetchCustomPageMap,
    ...stationGuideReducerMap,
});

export {
    fetchStationGuideAction,
    stationGuideSelectors,
};

export default {
    [namespace]: reducer,
};
